import React, { Fragment, useContext, useEffect } from "react";

import GroupBarChart from "../graphs/GroupBarChart";
import BarChartContainer from "./BarChartContainer";
import ParallelChart from "../graphs/ParallelChart";
import ParallelChart2 from "../graphs/ParallelChart2";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Col from "react-bootstrap/Col";
import ViewContext from "../../context/view/ViewContext";
import GaugeContext from "../../context/gauge/gaugeContext";
import MenuItem from "@material-ui/core/MenuItem";
import allFeatures from "../../context/FeaturesData";
import TabIcon from "@material-ui/icons/Tab";
import CancelIcon from "@material-ui/icons/Cancel";

import { select, scaleOrdinal, schemeSet1 } from "d3";

import { getNodeSize } from "../graphs/TreeChart";

const colorToolBar = (name) => {
	switch (name) {
		case "Alpha":
			return "red";
			break;
		case "Beta":
			return "blue";
			break;
		case "Gamma":
			return "purple";
			break;
		case "Delta":
			return "green";
			break;
		default:
			return "";
	}
};

const DashColumn = ({ node }) => {
	const gaugeContext = useContext(GaugeContext);
	const {
		removeNode,
		colorBy,
		selectNode,
		cal_nodesInUse_log_scale_min_max,
		nodesInUse,
	} = gaugeContext;
	const { setHiPlotModal, hiPlotModal } = useContext(ViewContext);

	useEffect(() => {
		cal_nodesInUse_log_scale_min_max();
	}, [nodesInUse]);

	const deleteColumn = (e) => {
		// Remove the styles on the selected node
		select(`.${node.name}`).attr("class", "node").attr("r", getNodeSize);
		select(`.${node.name}-text`).remove();
		removeNode(node.index, node.name);
	};

	// Lets create the color scale here so we can pass them to the dependent charts
	// This way, the colors are properly synchronized
	// const colors = ["E63946", "457B9D", "47A025", "C04ABC", "ADA9B7"]
	const userColorScale = scaleOrdinal()
		.domain(
			node.users.map((d) => {
				return d.key;
			})
		)
		.range(schemeSet1);

	const appColorScale = scaleOrdinal()
		.domain(
			node.apps.map((d) => {
				return d.key;
			})
		)
		.range(schemeSet1);

	// Initialize all the features as items for the scatter graph
	const renderScatterGraphOptions = () => {
		return allFeatures.map((f, i) => {
			return (
				<MenuItem label="Select a feature" value={f} key={i} name={f}>
					{f}
				</MenuItem>
			);
		});
	};

	const createHiPlot = (node) => {
		selectNode(node);
		setHiPlotModal(true);
	};

	return (
		<ViewContext.Consumer>
			{({ views }) => (
				<Fragment>
					<Col
						sm={12}
						lg={3}
						style={{ paddingTop: "10px", marginBottom: "50px" }}
					>
						<Paper elevation={3}>
							<AppBar style={{ position: "static" }}>
								<Toolbar
									style={{
										display: "flex",
										justifyContent: "space-between",
										background: colorToolBar(node.name),
									}}
								>
									<span className="col-title">
										{node.name}
									</span>
									<div>
										<Button
											onClick={() => createHiPlot(node)}
											style={{
												marginRight: "10px",
											}}
										>
											<TabIcon />
										</Button>
										<Button
											onClick={(e) => deleteColumn(e)}
										>
											<CancelIcon />
										</Button>
									</div>
								</Toolbar>
							</AppBar>

							{views.applications && (
								<Fragment>
									<BarChartContainer
										userData={node.users}
										appData={node.apps}
										userColorScale={userColorScale}
										appColorScale={appColorScale}
									/>
								</Fragment>
							)}

							{views.ratioFeatures && (
								<Fragment>
									<h1 style={h1Style}>Percentage Features</h1>
									<ParallelChart
										data={node.pfeatures}
										height={200}
										colorScale={
											colorBy === "user"
												? userColorScale
												: appColorScale
										}
									/>
								</Fragment>
							)}
							{views.logarithmicFeatures && (
								<Fragment>
									<h1 style={h1Style}>
										Logarithmic Features
									</h1>
									<ParallelChart2
										data={node.lfeatures}
										height={200}
										colorScale={
											colorBy === "user"
												? userColorScale
												: appColorScale
										}
									/>
								</Fragment>
							)}

							{views.scatterPlots && (
								<Fragment>
									<h1 style={h1Style}>Read/Write Access</h1>
									<GroupBarChart
										data={node.rw_access}
										height={100}
									/>
								</Fragment>
							)}
						</Paper>
					</Col>
				</Fragment>
			)}
		</ViewContext.Consumer>
	);
};

const h1Style = {
	display: "block",
	marginTop: "10px",
	color: "#707070",
	textAlign: "center",
	fontSize: "1em",
};
export default DashColumn;
